module.exports = __webpack_public_path__ + "static/media/bisque.b8373f71.jpg";